import { BehaviorSubject } from 'rxjs';


export const popupComponents$ = new BehaviorSubject([]);
export const currentNotification$ = new BehaviorSubject(null);

let pendingNotifications = [];
// setTimeout(()=>{
//     currentNotification$.next({message:'Some notification',type:'notify'})
// },1000)
export function addPopup (elem) {
    for (let popup of popupComponents$.value){
        if (!elem.popupData.confirmationDialogue && popup.popupData.configuration && elem.popupData.configuration && popup.popupData.configuration.formTitle === elem.popupData.configuration.formTitle){
            return;
        }
    }
    
    popupComponents$.next([...popupComponents$.value, elem])
}
export function addNotification (elem) {
    
    if (currentNotification$.getValue() === null){
        currentNotification$.next(elem);
        
        
        const myInterval = setInterval(()=>{
            if (pendingNotifications.length === 0){
                clearInterval(myInterval);
                currentNotification$.next(null);
                return;
            }
            currentNotification$.next(pendingNotifications.shift())

        }, elem.duration ? elem.duration : 3000);
    }else{
        pendingNotifications.push(elem);
    }
}